import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import CardTitle from 'src/components/card-title'
import useCardData from 'src/hooks/useCardData'
import { CoreButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import { useDispatch, useSelector } from 'react-redux'
import SelectionPopup from 'src/components/selection-popup'
import { EditorType } from 'src/model/card'
import CardSuneditor from 'src/components/card-suneditor'
import { DragDropEditor } from '../../components'
import { useLocation } from 'react-router-dom'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
const MidPages = props => {
  const { classes, sections, setSections } = props
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const { id, subPage } = useParams()
  const { cardData, isLoading } = useCardData()
  const section = sections.find(section => section.id === cardData?.sectionId)
  const course = useSelector(state => state.course.course)
  const openCardSelection = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Select page type',
          maxWidth: 800,
          component: (
            <SelectionPopup
              section={section}
              sections={sections}
              setSections={setSections}
              fromMidPage={true}
            />
          ),
        }),
      ),
    )
  }
  const editorType = EditorType[course?.editorType]
  return (
    <div
      style={{
        width: '100%',
        height: 'fit-content',
        minHeight: 'calc(100vh - 128px)',
        position: 'relative',
      }}
      id="page-view-container"
    >
      <div className={classes.container}>
        <CardTitle sections={sections} setSections={setSections} />
        {editorType === 'Legacy' ? (
          <CardSuneditor isLoading={isLoading} />
        ) : (
          cardData?.id == subPage && (
            <DragDropEditor data={cardData} isLoading={isLoading} />
          )
        )}
        <div
          style={{
            flexGrow: 1,
          }}
        />{' '}
        <div className={classes.buttonContainer}>
          <CoreButton
            startIcon={<Icon icon="uil:plus" />}
            fullWidth
            variant="outlined"
            className={classes.button}
            color="info"
            onClick={openCardSelection}
          >
            Add Page
          </CoreButton>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(MidPages)
